import React from "react";
import "./validation-error.scss";

interface ValidationErrorProps {
  children?: string;
  className?: string;
}

export const ValidationError: React.FC<ValidationErrorProps> = ({
  children,
  className = "",
}) => {
  if (!children) return null;

  return <div className={`validation-error ${className}`}>{children}</div>;
};
